<template>
  <div class="radio-wrapper" @click="select">
    <div :class="{ 'before:white-overlay': checked }">
      <div :class="classes" class="radio input link">
        <input
          :id="`radio-${$_uid}-input`"
          type="radio"
          :value="value"
          :checked="checked"
          :disabled="disabled"
          class="radio__input"
          @change.prevent="$emit('input', value)"
        />
        <div>
          <div>
            <label
              v-if="label"
              :id="`radio-${$_uid}-label`"
              :for="`radio-${$_uid}-input`"
              class="radio__label"
            >
              {{ label }}
            </label>
          </div>
          <div
            v-if="notice"
            :class="{ 'is-disabled': !checked }"
            class="notice-text notice-text--radio-default max-w-96"
          >
            <em class="text-sm">{{ notice }}</em>
          </div>
        </div>
      </div>
      <expand-height>
        <select-dropdown
          v-if="checked && intervalOptions.length"
          :value="subscriptionInterval"
          label="Frequency"
          :disabled="!checked"
          :options="intervalOptions"
          class="radio__embedded-select"
          @input="handleClick($event)"
        />
      </expand-height>
    </div>
  </div>
</template>

<script>
import SelectDropdown from '~/components/form/select-dropdown.vue'

export default {
  name: 'RecessRadio',

  components: {
    SelectDropdown
  },

  props: {
    label: {
      default: null,
      type: String
    },
    notice: {
      default: null,
      type: String
    },
    intervalOptions: {
      default: () => [],
      type: Array
    },
    subscriptionInterval: {
      default: null,
      type: String
    },
    value: {
      default: null,
      type: [String, Number]
    },
    checked: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    classes() {
      return {
        'is-disabled': this.disabled,
        'is-checked': this.checked
      }
    }
  },

  methods: {
    handleClick(event) {
      this.$emit('update:subscriptionInterval', event)
    },
    select() {
      this.$emit('input', this.value)
    }
  }
}
</script>

<style>
.dropdown__ui {
  max-width: 90% !important;
}

.dropdown__button--collapsed {
  background: var(--background-color) !important;
}

.dropdown__label {
  padding-left: 0 !important;
}

.radio-wrapper {
  background: var(--background-color);
  border: 2px solid var(--input-text-color);
  border-radius: 39px;
  cursor: pointer;
  margin-bottom: calc(var(--cart-gutter-y) / 3);
  padding: 16px;
  position: relative;
}

.before\:white-overlay::before {
  background-color: theme('colors.white');
  border-radius: 39px;
  content: '';
  display: block;
  height: 100%;
  left: 0;
  opacity: 0.5;
  position: absolute;
  top: 0;
  transition: opacity var(--hover-speed);
  width: 100%;
  z-index: 1;
}

.radio {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  flex-wrap: nowrap;
  position: relative;
  z-index: 2;
}

.radio__embedded-select {
  margin-bottom: 6px;
  margin-top: calc(var(--cart-gutter-y) / 2);
  padding-left: calc(var(--input-gutter) * 2);
}

.radio__label {
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  line-height: 20px;
  width: fit-content;
}

.radio__input {
  border: var(--input-border);
  border-radius: 100%;
  display: block;
  flex: 0 0 auto;
  height: var(--input-radio-size);
  transition: background-color var(--hover-speed),
    border-color var(--hover-speed);
  width: var(--input-radio-size);
}

.radio.is-checked,
.radio.is-checked .radio__label,
.radio.is-checked .radio__input {
  cursor: default;
}

.radio__input:focus {
  outline: 0;
}

.radio__input:checked {
  background-color: var(--input-text-color);
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.58694 4.67111C2.21552 5.14128 2.84447 5.64285 3.47308 6.14439C4.94018 4.10667 6.40728 2.03762 7.87438 0C8.59292 0.564363 9.28146 1.09737 10 1.66129C7.99392 4.45137 5.98784 7.24134 3.98215 10C2.66461 8.96546 1.31745 7.89953 0 6.86501C0.539013 6.14406 1.04806 5.39173 1.58664 4.6707L1.58694 4.67111Z' fill='%23F9D8C4'/%3E%3C/svg%3E%0A");
  background-position: center;
  background-repeat: no-repeat;
}

.radio.is-checked:hover,
[data-js-focus-visible]
  .radio.is-checked
  .radio__input[data-focus-visible-added] {
  color: inherit;
}

.radio:hover .radio__input:not(:checked),
[data-js-focus-visible] .radio__input:not(:checked)[data-focus-visible-added] {
  background-color: var(--input-background-color);
  border-color: var(--link-color);
}

.notice-text {
  display: inline-block;
  opacity: 0.75;
  padding-top: 0.25em;
  transition: opacity var(--fade-speed);

  @apply leading-tight;
}

.notice-text.is-disabled {
  opacity: 0.6;
  pointer-events: none;
}

.notice-text--radio-default {
  padding-left: calc(var(--input-gutter));
}
</style>
